<!--
  ABtn — Pineapple 표준 버튼
  kinds: primary (검은 배경) / yellow / ghost / danger
  sizes: sm / md
  슬롯: 기본(라벨) · icon (앞 아이콘)
-->
<template>
  <button :class="['a-btn', `a-btn--${kind}`, `a-btn--${size}`]" :type="type" :disabled="disabled" @click="$emit('click', $event)">
    <span v-if="$slots.icon" class="a-btn__icon"><slot name="icon" /></span>
    <slot />
  </button>
</template>

<script>
export default {
  name: 'ABtn',
  emits: ['click'],
  props: {
    kind: {
      type: String,
      default: 'ghost',
      validator: (v) => ['primary', 'yellow', 'ghost', 'danger'].includes(v),
    },
    size: {
      type: String,
      default: 'md',
      validator: (v) => ['sm', 'md'].includes(v),
    },
    type: { type: String, default: 'button' },
    disabled: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_pineapple.scss';

.a-btn {
  border-radius: 8px;
  font-family: $p-font-body;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  white-space: nowrap;
  transition: filter 0.15s ease, background 0.15s ease;
  border: 1px solid transparent;

  &:disabled { opacity: 0.55; cursor: not-allowed; }
  &:not(:disabled):hover { filter: brightness(0.96); }

  &--primary { background: $p-ink;    color: #fff;     border-color: $p-ink; }
  &--yellow  { background: $p-point;  color: $p-ink;   border-color: $p-point-deep; }
  &--ghost   { background: $p-panel;  color: $p-ink;   border-color: $p-line; }
  &--danger  { background: $p-panel;  color: $p-err;   border-color: $p-line; }

  &--sm { height: 28px; padding: 0 10px; font-size: 11px; }
  &--md { height: 36px; padding: 0 14px; font-size: 12px; }

  &__icon { display: inline-flex; align-items: center; line-height: 0; }
}
</style>
